import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { DragDropContext, DropResult } from "@hello-pangea/dnd";
import ContentBox from "../../ContentBox/ContentBox";
import { StrictModeDroppable } from "../../BeaAttachments/StrictModeDroppable";
import { ExecutionStep } from "./ExecutionStepFormShared";
import ExecutionJobStepRow from "./ExecutionJobStepRow";

type ExecutionJobStepsTableProps = {
  executionJobId: number;
  steps: ExecutionStep[];
  openStepIds: number[];
  canReorderSteps: boolean;
  isJobPendingApproval: boolean;
  onReorder: (result: DropResult) => Promise<void>;
  onToggleStepOpen: (stepId: number) => void;
  onToggleStepSkipped: (step: ExecutionStep) => Promise<void>;
  stepIdsWithPendingStatusToggle: number[];
};

const ExecutionJobStepsTable = ({
  executionJobId,
  steps,
  openStepIds,
  canReorderSteps,
  isJobPendingApproval,
  onReorder,
  onToggleStepOpen,
  onToggleStepSkipped,
  stepIdsWithPendingStatusToggle,
}: ExecutionJobStepsTableProps) => (
  <ContentBox headline={"Schritte"}>
    {steps.length === 0 ? (
      <Typography>Dieser Job enthält keine Schritte.</Typography>
    ) : (
      <TableContainer>
        <DragDropContext onDragEnd={onReorder}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell />
                <TableCell>Position</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Ausgeführt</TableCell>
                <TableCell align={"right"} />
              </TableRow>
            </TableHead>
            <StrictModeDroppable droppableId={`execution-job-steps-${executionJobId}`}>
              {(provided) => (
                <TableBody ref={provided.innerRef} {...provided.droppableProps}>
                  {steps.map((step, index) => {
                    const isOpen = openStepIds.includes(step.id);

                    return (
                      <ExecutionJobStepRow
                        key={step.id}
                        index={index}
                        isJobPendingApproval={isJobPendingApproval}
                        step={step}
                        isOpen={isOpen}
                        isDragDisabled={!canReorderSteps || isOpen}
                        isStatusTogglePending={stepIdsWithPendingStatusToggle.includes(step.id)}
                        onToggleStepOpen={onToggleStepOpen}
                        onToggleStepSkipped={onToggleStepSkipped}
                      />
                    );
                  })}
                  {provided.placeholder}
                </TableBody>
              )}
            </StrictModeDroppable>
          </Table>
        </DragDropContext>
      </TableContainer>
    )}
  </ContentBox>
);

export default ExecutionJobStepsTable;
